module.exports = __webpack_public_path__ + "img/活动中心.27132794.png";